import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const UpdateCardCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCardComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idAction"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"text"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"traceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCardComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idAction"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idAction"}}},{"kind":"Argument","name":{"kind":"Name","value":"text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"text"}}},{"kind":"Argument","name":{"kind":"Name","value":"traceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"traceId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"UpdateCardComment","document":UpdateCardCommentDocument}} as const;
export type UpdateCardCommentMutationVariables = Types.Exact<{
  idAction: Types.Scalars['ID']['input'];
  text: Types.Scalars['String']['input'];
  traceId: Types.Scalars['String']['input'];
}>;


export type UpdateCardCommentMutation = (
  { __typename: 'Mutation' }
  & { updateCardComment?: Types.Maybe<(
    { __typename: 'Action' }
    & Pick<Types.Action, 'id'>
  )> }
);

export type UpdateCardCommentMutationFn = Apollo.MutationFunction<
  UpdateCardCommentMutation,
  UpdateCardCommentMutationVariables
>;

/**
 * __useUpdateCardCommentMutation__
 *
 * To run a mutation, you first call `useUpdateCardCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCardCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCardCommentMutation, { data, loading, error }] = useUpdateCardCommentMutation({
 *   variables: {
 *      idAction: // value for 'idAction'
 *      text: // value for 'text'
 *      traceId: // value for 'traceId'
 *   },
 * });
 */
export function useUpdateCardCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCardCommentMutation,
    UpdateCardCommentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCardCommentMutation,
    UpdateCardCommentMutationVariables
  >(UpdateCardCommentDocument, options);
}
export type UpdateCardCommentMutationHookResult = ReturnType<
  typeof useUpdateCardCommentMutation
>;
export type UpdateCardCommentMutationResult =
  Apollo.MutationResult<UpdateCardCommentMutation>;
export type UpdateCardCommentMutationOptions = Apollo.BaseMutationOptions<
  UpdateCardCommentMutation,
  UpdateCardCommentMutationVariables
>;
